import { ShieldAlert } from "lucide-react";
import { HELPER_LINE } from "@/tax/disclaimer";

/**
 * Legacy `TaxDisclaimer` — kept as a thin wrapper so any older screen that
 * still imports it renders the same unified helper line as the newer
 * `<AtoDisclaimer />`. New screens should prefer the typed
 * `<AtoDisclaimer context="…" />`.
 */
export default function TaxDisclaimer({ compact = false, testid = "tax-disclaimer" }) {
  if (compact) {
    return (
      <div
        data-testid={testid}
        className="text-[10px] text-white/50 inline-flex items-start gap-1 leading-snug"
      >
        <ShieldAlert className="w-3 h-3 mt-0.5 shrink-0 text-white/40" />
        <span>{HELPER_LINE}</span>
      </div>
    );
  }
  return (
    <div
      data-testid={testid}
      className="rounded-lg border border-white/5 bg-white/[0.03] p-2.5 text-[11px] text-white/70 leading-snug flex items-start gap-2"
    >
      <ShieldAlert className="w-3.5 h-3.5 mt-0.5 shrink-0 text-[#FBBF24]" />
      <span>{HELPER_LINE}</span>
    </div>
  );
}
